var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"solid-table"},[_c('el-table',{attrs:{"data":_vm.tableData}},_vm._l((_vm.columns),function(col){return _c('el-table-column',{key:col.prop,attrs:{"prop":col.prop,"label":col.label,"type":col.type}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }